import { Database } from "@/integrations/supabase/types";

type Invoice = Database['public']['Tables']['invoices']['Row'];

export const convertInvoicesToCSV = (invoices: Invoice[]) => {
  if (!invoices || invoices.length === 0) return '';
  
  // Define the exact order of columns as they appear in the database
  const columnOrder = [
    'id',
    'user_id',
    'invoice_number',
    'amount',
    'description',
    'file_name',
    'uploaded_at',
    'due_date',
    'issue_date',
    'recipient_name',
    'recipient_email',
    'recipient_address',
    'business_name',
    'business_tax_id',
    'business_iban',
    'business_swift',
    'business_email',
    'business_phone',
    'client_tax_id',
    'client_phone',
    'quantity',
    'unit_price',
    'subtotal',
    'bank_account_holder',
    'bank_iban',
    'bank_name',
    'bank_swift',
    'payment_reference',
    'status',
    'payment_url'
  ];
  
  // Create CSV header row using the defined column order
  const headerRow = columnOrder.join(',');
  
  // Create CSV rows from data, ensuring values appear in the correct columns
  const rows = invoices.map(invoice => {
    return columnOrder.map(column => {
      const value = invoice[column as keyof Invoice];
      
      // Handle special cases (null, undefined, strings with commas)
      if (value === null || value === undefined) return '';
      
      if (typeof value === 'string') {
        // Replace any double quotes with two double quotes (CSV escaping)
        // Also handle newlines by wrapping the entire field in quotes
        const escapedValue = value.replace(/"/g, '""');
        return `"${escapedValue}"`;
      }
      
      // Check if the value is a timestamp (these fields are known to be timestamps)
      if (column.includes('_at') || column.includes('_date')) {
        return value.toString();
      }
      
      return value;
    }).join(',');
  });
  
  // Combine header and rows
  return [headerRow, ...rows].join('\n');
};

export const downloadCSV = (csvContent: string, fileName: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};